import {
  Array,
  Boolean,
  Literal,
  Record,
  Static,
  String,
  Union,
} from 'runtypes';

export const InvoiceTotalModifierRuntype = Union(
  Literal('add'),
  Literal('subtract'),
  Literal('none'),
);

export const redemptionFields = {
  name: String,
  invoiceTotalModifier: InvoiceTotalModifierRuntype,
  addAbsValueToSalesTotal: Boolean.optional(),
};

export const RedemptionRuntype = Record({
  id: String,
  ...redemptionFields,
});

export const RedemptionsRuntype = Array(RedemptionRuntype);

export const CreateRedemptionInputRuntype = Record({
  season: String,
  ...redemptionFields,
});

export type Redemption = Static<typeof RedemptionRuntype>;
export type InvoiceTotalModifier = Static<typeof InvoiceTotalModifierRuntype>;
export type CreateRedemptionInput = Static<typeof CreateRedemptionInputRuntype>;
